import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Plugins } from '@capacitor/core';
import { Apollo } from 'apollo-angular';
const { Storage } = Plugins;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private BASE_URL: string;

  private readonly X_AUTH_TOKEN_STORAGE_KEY = "x-auth-token";
  private readonly X_TENANT_USER_ID_TOKEN_STORAGE_KEY = "x-tenant-user-id";
  private readonly MFA_TOKEN_STORAGE_KEY = "x-mfa-token";

  constructor(
    private readonly httpClient: HttpClient,
    private apollo: Apollo
    ) {
    this.BASE_URL = environment['restApiUrl'];
  }

  public async getAuthToken(): Promise<string> {
    return (await Storage.get({ key: this.X_AUTH_TOKEN_STORAGE_KEY })).value;
  }

  async getMfaToken(): Promise<string | null> {
    return (await Storage.get({ key: this.MFA_TOKEN_STORAGE_KEY })).value;
  }

  public async getTenantUserId(): Promise<string> {
    return (await Storage.get({ key: this.X_TENANT_USER_ID_TOKEN_STORAGE_KEY })).value;
  }

  public async authenticated(): Promise<boolean> {
    const response: any = await this.httpClient
      .get(`${this.BASE_URL}/auth-proxy/authenticated`)
      .toPromise();
    return response.authenticated;
  }

  public async fullyAuthenticated(): Promise<boolean> {
    return !!(await this.getAuthToken()) && !!(await this.getTenantUserId());
  }

  public async clearAuthStorage(): Promise<void> {
    await Promise.all([
      Storage.remove({ key: this.X_AUTH_TOKEN_STORAGE_KEY }),
      Storage.remove({ key: this.MFA_TOKEN_STORAGE_KEY }),
      Storage.remove({ key: this.X_TENANT_USER_ID_TOKEN_STORAGE_KEY }),
    ]);
    await this.apollo.client.resetStore();
  }
}
